import React, { useState } from "react";

import NumberInput from "../components/NumberInput";
import DayInput from "../components/DayInput";
import { calculateDeliveryPrice, validateOrderTime } from "../utils";

const DeliveryFeeCalculator: React.FC = () => {
  const [itemsCount, setItemsCount] = useState<number>(0);
  const [cartValue, setCartValue] = useState<number>(0);
  const [deliveryDistance, setDeliveryDistance] = useState<number>(0);
  const [orderTime, setOrderTime] = useState<string>("");
  const [deliveryPrice, setDeliveryPrice] = useState<number | null>(null);

  const isFormValid =
    cartValue > 0 &&
    deliveryDistance > 0 &&
    itemsCount > 0 &&
    orderTime.trim() !== "";

  const handleCalculatePrice = () => {
    try {
      validateOrderTime(orderTime);
      const price = calculateDeliveryPrice(
        cartValue,
        deliveryDistance,
        itemsCount,
        orderTime
      );
      setDeliveryPrice(price);
    } catch (e) {
      alert(e);
      setDeliveryPrice(null);
    }
  };

  const handleCartValueChange = (value: number) => {
    setCartValue(value);
    setDeliveryPrice(null);
  };

  const handleDeliveryDistanceChange = (value: number) => {
    console.log(value);
    setDeliveryDistance(value);
    setDeliveryPrice(null);
  };

  const handleItemsCountChange = (value: number) => {
    setItemsCount(value);
    setDeliveryPrice(null);
  };

  const renderDeliveryPriceMessage = () => {
    if (!isFormValid || deliveryPrice === null) return null;

    if (deliveryPrice === 0) {
      return (
        <p className="text-lg mt-4 text-green-500">
          Congrats, your delivery is free! <span>&#129395;</span>
        </p>
      );
    }

    return (
      <p className="text-lg mt-4">
        Delivery price: {deliveryPrice.toFixed(2)} <span>&#8364;</span>
      </p>
    );
  };

  return (
    <div className="container relative max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Delivery Fee Calculator</h1>

      <NumberInput
        label="Cart Value:"
        value={cartValue}
        placeholder="e.g. 20&#8364;"
        unit="&#8364;"
        onChange={handleCartValueChange}
        min={0}
        errorMessage="Cart value must be greater than or equal to 0."
      />

      <NumberInput
        label="Delivery Distance:"
        value={deliveryDistance}
        placeholder="e.g. 900m"
        unit="m"
        onChange={handleDeliveryDistanceChange}
        min={0}
        errorMessage="Delivery distance must be greater than or equal to 0."
      />

      <NumberInput
        label="Amount of Items:"
        value={itemsCount}
        placeholder="e.g. 5"
        onChange={handleItemsCountChange}
        min={0}
        errorMessage="Items count must be greater than or equal to 0."
      />

      <DayInput
        label="Order Time:"
        value={orderTime}
        unit="UTC"
        onChange={setOrderTime}
      />

      <button
        className={`font-roboto font-bold bg-black text-white py-4 px-6 rounded-full mt-4 hover:opacity-60 ${
          !isFormValid ? "cursor-not-allowed" : ""
        }`}
        onClick={handleCalculatePrice}
        disabled={!isFormValid}
      >
        Calculate delivery price
      </button>

      {renderDeliveryPriceMessage()}
    </div>
  );
};

export default DeliveryFeeCalculator;
